import { useQuery } from "@apollo/client";
import { Container, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { GET_CONCERT_PROGRAM } from "../../../quries/concert_video";
import ConcertMaterial from "./ConcertMaterial";
import ConcertPageInfo from "./ConcertPageInfo";

interface ConcertPageComponentProps {
  history: any;
  match: any;
  location: any;
  //   rowData: any;
}
function ConcertPageComponent({
  match,
  location,
  history,
}: ConcertPageComponentProps) {
  const { data, loading, error } = useQuery(GET_CONCERT_PROGRAM, {
    fetchPolicy: "no-cache",

    variables: {
      id: match.params.concert_program_id,
    },
  });

  const [concertProgram, setConcertProgram] = useState<any>(null);
  useEffect(() => {
    if (data && data.concertProgram) {
      setConcertProgram(data.concertProgram);
    }
    return () => {
      setConcertProgram(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.concertProgram) {
    console.log(error);
  }

  if (concertProgram) {
    return (
      <Container maxWidth={"xl"} disableGutters style={{}}>
        <Grid xs={12} item container justify="center" style={{}}>
          <ConcertPageInfo rowData={concertProgram} />
          <ConcertMaterial concertUrl={concertProgram.concert_videos} />
        </Grid>
      </Container>
    );
  } else {
    return <div>자료가 없습니다</div>;
  }
}
export default ConcertPageComponent;
